import React from "react";
import { Provider } from "react-redux";
import CLWSAuthZCaller from "./exportable/CLWSAuthZCaller";
import store from "./store";
var CLWSCallerApp = function(param) {
    var isPageAuthorized = param.isPageAuthorized, authorizationDispatch = param.authorizationDispatch;
    return /*#__PURE__*/ React.createElement(Provider, {
        store: store
    }, isPageAuthorized && /*#__PURE__*/ React.createElement(CLWSAuthZCaller, {
        authorizationDispatch: authorizationDispatch
    }));
};
export default CLWSCallerApp;
CLWSCallerApp.propTypes = {};

//# sourceMappingURL=CLWSCallerApp.js.map